import { redirect } from '@tanstack/react-router';
import { appModules } from '@/modules/core';
import { findNavItem, isVisible } from '@/modules/registry';
import type { AuthState } from './auth';

/**
 * Route guard driven by the module registry, so a page and its sidebar entry share one
 * permission rule. Signed-out users go to /login; users without access go to the dashboard.
 * The API enforces the same rules (it is the source of truth).
 */
export function guardRoute(auth: AuthState, path: string): void {
  if (!auth.user) throw redirect({ to: '/login' });
  const item = findNavItem(appModules, path);
  if (item && !isVisible(item, auth.user)) throw redirect({ to: '/' });
}
